import { ObjectSchema, object, string, number, mixed } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { FuUnit, CommunicationType, communicationTypes } from './../../models/fu-unit';
import './../custom-method';

yup.setLocale(locale);

export const fuUnitLocationLenLimit = 16;
export function fuUnitValidator(): ObjectSchema<FuUnit> {
    return object({
        id: string().uuid().strict(),
        fcuId: string().uuid().strict(),
        vesselId: string().uuid().strict(),
        index: number().required().nonNullable().strict(),
        location: string().nullable().strict().max(fuUnitLocationLenLimit),
        communicationType: mixed<CommunicationType>().oneOf(Object.values(communicationTypes)).nullable().strict(),
        fieldNetLineAIp: string().isIp().nullable().strict(),
        fieldNetLineBIp: string().isIp().nullable().strict(),
    })
        .strict()
        .noUnknown();
}
